import { useEffect, useState } from 'react';
import { ProfileCard, ChangePasswordCard } from '@podus/ui';
import { api } from '@/lib/api';
import type { StaffMember } from '@/types';

export default function MediatorSettings() {
    const [profile, setProfile] = useState<StaffMember | null>(null);

    const fetchProfile = async () => {
        try {
            const res = await api.get<StaffMember>('/api/settings/profile');
            if (res.response.data) setProfile(res.response.data);
        } catch (err) {
            console.error('Failed to fetch profile:', err);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    return (
        <div className="px-4 lg:px-8 py-6">
            <h1 className="mb-6 text-2xl font-bold text-secondary sm:text-3xl">Settings</h1>

            <div className="grid gap-5 lg:grid-cols-2">
                <ProfileCard
                    profile={profile}
                    onSave={async (updates) => {
                        await api.patch('/api/settings/profile', updates);
                        await fetchProfile();
                    }}
                />
                <ChangePasswordCard
                    onSubmit={async (data) => {
                        await api.post('/api/settings/change-password', data);
                    }}
                />
            </div>
        </div>
    );
}
